import styled from 'styled-components'

export const StyledHome = styled.div``
